import {HttpAxiosRequest} from "../httpAxiosBase";
import {User} from "../../types/user/authData";
import {BaseResponse} from "../../types/baseEntities";


export const HttpOnboardingUser = {
    getEndpoint: (url = ''): string => `onboarding-user${url}`,
    
    getData : () : Promise<User> => {
        return HttpAxiosRequest.get(
            HttpOnboardingUser.getEndpoint()
        )
    },
    
    updateData : (userData: User) : Promise<BaseResponse> => {
        return HttpAxiosRequest.put(
            HttpOnboardingUser.getEndpoint(), userData
        )
    }
}